<template>
  <div class="product-detail pt80">
    <!-- 导航栏 -->
    <Navbar />
    <div class="container">
      <!-- 面包屑导航 -->
      <el-breadcrumb separator=">">
        <el-breadcrumb-item :to="{ path: '/' }">Página Inicial</el-breadcrumb-item>
        <el-breadcrumb-item>{{ category.name }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div v-if="productList.length > 0">
        <el-row :gutter="20">
          <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-for="item in productList" :key="item.id">
            <div class="product-card" @click="goToDetail(item)">
              <div class="product-image-box">
                <div class="hover-box">
                  <el-button type="main" class="add-btn" round size="small" icon="el-icon-goods" @click.stop="addToCart(item)">Adicionar ao Carrinho</el-button>
                </div>
                <img :src="item.cover || ''" class="product-image" />
              </div>
              <div style="padding: 12px 10px;">
                <div class="product-name">{{ item.name }}</div>
                <div class="product-desc">{{ item.code }}</div>
                <div class="product-price">
                  <span class="price">R$ {{ item.price }}</span>
                  <span class="stock">{{ item.stock }} em stock</span>

                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 加载状态 -->
      <div v-else class="loading">
        <el-loading text="Carregando..."></el-loading>
      </div>

      <div class="view-more" v-if="hasMore">
        <el-button
            class="view-more-btn"
            @click="viewMore"
            :loading="loading"
            :disabled="loading"
        >
          {{ loading ? 'Carregando...' : 'Ver mais' }}
        </el-button>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import { categoryDetail } from '@/api/home'
import { getProductList } from '@/api/product'
import Footer from "@/components/Footer.vue";


export default {
  name: 'Category',
  components: {
    Footer,
    Navbar
  },
  data() {
    return {
      hasMore: false,
      query: {
        page: 1,
        size: 1
      },
      total: 0,
      category: {},
      productList: [],
      activeTab: 'detail',
      selectedImage: '',
      selectedCapacity: '15ml',
      quantity: 1,
      isFavorite: false,
      product: null
    }
  },
  watch: {
    // 监听路由参数变化
    '$route.query.cate_id': {
      handler(newCateId) {
        if (newCateId) {
          // 重置数据
          this.query.page = 1
          this.productList = []
          this.query.cate_id = newCateId
          this.getCategoryDetail()
          this.getCategoryProduct()
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.query.cate_id = this.$route.query.cate_id
    this.getCategoryDetail()
    this.getCategoryProduct()
  },
  methods: {
    viewMore(){
      //加载更多
      this.query.page++
      this.getCategoryProduct()
      this.loading = false;
    },
    goToDetail(item){
      this.$router.push({
        path: '/product/' + item.goods_id,
      })

    },
    getCategoryProduct(){
      getProductList(this.query).then(res => {
        console.log('getProductList',res)
        if(this.query.page === 1){
          this.productList = [];
        }
        //分页的逻辑
        // this.query.page = res.data.current_page || 1
        // this.query.size = res.data.per_page
        this.total = res.data && res.data.total || 0;
        const newData = res.data && res.data.data || [];
        this.productList = [...this.productList, ...newData];
        this.hasMore = res.data &&  res.data.has_more;
        if(this.hasMore){
          this.query.page++;
        }
      }).catch(err=>{
        console.log('err',err)
      })

    },
    getCategoryDetail() {
      // 模拟从API加载商品数据
      const cateId = this.$route.query.cate_id;
      categoryDetail({
        id: cateId
      }).then(res => {
        console.log('categoryDetail',res)
        this.category = res.data;
      }).catch(err=>{
        console.log('err',err)
      })
    },
    addToCart() {
      this.$message.success(`${this.product.name} Adicionado ao carrinho`)
    },
    buyNow() {
      this.$message.success('Ir para a página de fechamento')
    },
    toggleFavorite() {

    }
  }
}
</script>

<style lang="scss" scoped>

.product-card {
  cursor: pointer;
  transition: transform 0.3s;
  margin-bottom: 20px;
}

.product-card:hover {
  transform: translateY(-5px);
}
.product-image-box{
  position: relative;
  .hover-box{
    position: absolute;
    bottom: 30px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    .add-btn{
      background: #00c950;
      color: #fff;
      border-color: #00c950;
    }
  }
  &:hover .hover-box{
    opacity: 1;
  }
  .product-image {
    width: 100%;
    height: 400px;
    object-fit: cover;
    display: block;
  }
}



.product-name {
  font-weight: 600;
  color: #111;
  font-size: 1rem;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.product-desc {
  font-size: 0.875rem;
  color: #6b7280;
  display: block;
  margin-bottom: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.product-price {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .stock{
    color: #6b7280;
    font-size: 0.875rem;
  }
}

.price {
  height: 30px;
  border: 2px solid #e60013;
  border-radius: 4px;
  color: #e60013;
  font-size: 0.875rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
}

/* Ver mais 按钮样式 */
.view-more {
  text-align: center;
  margin-top: 40px;
  padding: 20px 0;
}

.view-more-btn {
  background-color: #111;
  border-color: #111;
  color: white;
  padding: 12px 30px;
  font-size: 16px;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.view-more-btn:hover {
  background-color: #111;
  border-color: #111;
  color: white;
  transform: translateY(-2px);
}

.view-more-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.loading {
  text-align: center;
  padding: 100px 0;
}
</style>
